export default __webpack_public_path__ + "static/blog-0-00-8b5aa939d3bfde0bcb430b5ea502d13f.png";